import React from 'react';
import './App.css';
import UniversalHeader from './UniversalHeader';

function Analytics() {
  const [range, setRange] = React.useState('30d');

  return (
    <div className="analytics-root">
      <UniversalHeader />

      <div className="analytics-shell">
        <header className="analytics-header">
          <div>
            <h1 className="analytics-title">Analytics</h1>
            <p className="analytics-subtitle">
              High-level performance for rent, occupancy, and maintenance.
            </p>
          </div>

          <div className="analytics-actions">
            <div className="analytics-range">
              <button
                type="button"
                className={`analytics-range-chip ${range === '7d' ? 'analytics-range-chip--active' : ''}`}
                onClick={() => setRange('7d')}
              >
                7d
              </button>
              <button
                type="button"
                className={`analytics-range-chip ${range === '30d' ? 'analytics-range-chip--active' : ''}`}
                onClick={() => setRange('30d')}
              >
                30d
              </button>
              <button
                type="button"
                className={`analytics-range-chip ${range === '90d' ? 'analytics-range-chip--active' : ''}`}
                onClick={() => setRange('90d')}
              >
                90d
              </button>
            </div>
            <button
              type="button"
              className="btn-ghost analytics-btn"
              onClick={() => alert('Export as CSV/PDF (wire later).')}
            >
              Export
            </button>
          </div>
        </header>

        <main className="analytics-layout">
          <section className="analytics-summary">
            <div className="analytics-card">
              <div className="analytics-card-header">
                <span className="analytics-card-label">Rent collected</span>
                <span className="analytics-pill analytics-pill--success">+8.2% vs last {range}</span>
              </div>
              <p className="analytics-card-value">$184,300</p>
              <p className="analytics-card-caption">Out of $199,000 due</p>
            </div>

            <div className="analytics-card">
              <div className="analytics-card-header">
                <span className="analytics-card-label">Occupancy rate</span>
                <span className="analytics-pill">97.4%</span>
              </div>
              <p className="analytics-card-value">97.4%</p>
              <p className="analytics-card-caption">Across 3 active properties</p>
            </div>

            <div className="analytics-card">
              <div className="analytics-card-header">
                <span className="analytics-card-label">Maintenance</span>
                <span className="analytics-pill analytics-pill--muted">Response ~2.1 hrs</span>
              </div>
              <p className="analytics-card-value">24</p>
              <p className="analytics-card-caption">Requests resolved in this {range}</p>
            </div>
          </section>

          <section className="analytics-main-grid">
            <div className="analytics-chart-card">
              <div className="analytics-chart-header">
                <span className="analytics-card-label">Rent collection trend</span>
                <span className="analytics-card-caption">By month</span>
              </div>
              <div className="analytics-chart-body">
                <div className="analytics-chart-bg" />
                <svg
                  className="analytics-chart-svg"
                  viewBox="0 0 100 40"
                  preserveAspectRatio="none"
                >
                  <defs>
                    <linearGradient id="analyticsArea" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="rgba(37,99,235,0.35)" />
                      <stop offset="100%" stopColor="rgba(191,219,254,0.02)" />
                    </linearGradient>
                  </defs>
                  <path
                    d="M0,30 L10,26 L25,23 L40,21 L55,18 L70,16 L85,17 L100,18 L100,40 L0,40 Z"
                    fill="url(#analyticsArea)"
                  />
                  <polyline
                    fill="none"
                    stroke="#2563eb"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    points="0,30 10,26 25,23 40,21 55,18 70,16 85,17 100,18"
                  />
                </svg>
                <div className="analytics-chart-xlabels">
                  <span>Jan</span>
                  <span>Feb</span>
                  <span>Mar</span>
                  <span>Apr</span>
                  <span>May</span>
                  <span>Jun</span>
                </div>
              </div>
            </div>

            <div className="analytics-chart-card">
              <div className="analytics-chart-header">
                <span className="analytics-card-label">Occupancy by property</span>
                <span className="analytics-card-caption">Bar view</span>
              </div>
              <div className="analytics-bars">
                {[
                  { label: 'Elm Court', value: 98 },
                  { label: 'Maple Heights', value: 95 },
                  { label: 'Harbor View', value: 89 },
                ].map((row) => (
                  <div key={row.label} className="analytics-bar-row">
                    <span className="analytics-bar-label">{row.label}</span>
                    <div className="analytics-bar-track">
                      <div
                        className="analytics-bar-fill"
                        style={{ width: `${row.value}%` }}
                      />
                    </div>
                    <span className="analytics-bar-value">{row.value}%</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="analytics-chart-card analytics-chart-card--wide">
              <div className="analytics-chart-header">
                <span className="analytics-card-label">Maintenance breakdown</span>
                <span className="analytics-card-caption">Completed vs open</span>
              </div>
              <div className="analytics-maint-grid">
                <div className="analytics-pie">
                  <div className="analytics-pie-inner">
                    <span>76%</span>
                    <span>Completed</span>
                  </div>
                </div>
                <div className="analytics-maint-legend">
                  <div className="analytics-legend-row">
                    <span className="analytics-legend-dot analytics-legend-dot--blue" />
                    <span>Completed</span>
                    <span className="analytics-legend-value">38</span>
                  </div>
                  <div className="analytics-legend-row">
                    <span className="analytics-legend-dot analytics-legend-dot--amber" />
                    <span>In progress</span>
                    <span className="analytics-legend-value">9</span>
                  </div>
                  <div className="analytics-legend-row">
                    <span className="analytics-legend-dot analytics-legend-dot--gray" />
                    <span>Pending</span>
                    <span className="analytics-legend-value">3</span>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}

export default Analytics;

